import React, { useState, useEffect, useMemo } from 'react';

import { CenteredContainer, LoadingSkeleton } from '../../components';
import * as Styled from './styled';
import * as GStyled from '../../styles/components';
import { StyledText } from '@leasequery/lq.react-component-library';
import { ExportResult } from '../../models';
import { fetchExportResults } from '../../api';
import RecentExportsTable from './recent-exports-table/RecentExportsTable';
import { useAuth, useInprogressReports } from '../../context';
import withClient from '../../components/with-client/withClient';
import { ViewAllClients } from './client-toggle/ViewAllClients';
import { updateReportResultStatusFromInprogressReports } from './helpers';
//import { useRouter } from 'next/router';

function ExportResults(): JSX.Element {

  const { user, client } = useAuth();
  const [exportResults, setExportResults] = useState<ExportResult[]>(null);
  const [displayCurrentClientOnly, setDisplayCurrentClientOnly] = useState(
    true
);
  const [inprogressReport] = useInprogressReports();

  // TODO: update this to be loading exports
  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      const resp = (await fetchExportResults()) as ExportResult[];
      setExportResults(resp);
    };
    fetchData();
  }, []);

  const displayedExportResults = useMemo(() => {
    const filteredReports = displayCurrentClientOnly && exportResults
        ? exportResults.filter((x) => x.companyName === client.companyName)
        : exportResults;
    return updateReportResultStatusFromInprogressReports(
      filteredReports,
      inprogressReport,
    );
  }, [
    displayCurrentClientOnly,
    exportResults,
    inprogressReport,
    client.companyName,
  ]);

  return (
    <CenteredContainer>
      <Styled.PageHeaderWrapper>
        <GStyled.PageHeader>
          Export Results for {user.firstName}
        </GStyled.PageHeader>
        <StyledText as="div">
          All export results will be stored for{' '}
          <StyledText fontWeight="bold">14 days</StyledText>.
        </StyledText>
      </Styled.PageHeaderWrapper>
      <Styled.Section>
        <Styled.RecentReportTitleBar>
          <StyledText fontWeight="bold" size="xl">
            Recent Export Results
          </StyledText>
          {user.isMultiClientUser && user.canAccessMultipleClients && (
            <ViewAllClients
              filterStatus={displayCurrentClientOnly}
              updateFilterStatus={setDisplayCurrentClientOnly}
            />
          )}
        </Styled.RecentReportTitleBar>
        {!displayedExportResults ? (
          <LoadingSkeleton name="table" />
        ) : (
          <RecentExportsTable exportResults={displayedExportResults} />
        )}
      </Styled.Section>
    </CenteredContainer>
  );
}

export default withClient(ExportResults);
